<template>
  <v-row>
    <v-col>
      <div v-if="showCard">
        <CardsView
          :items="holidays"
          :subtitle="subtitle"
          :openDialog="openDialog"
          @refreshItems="refreshItems"
          :showRefresh="true"
        />
      </div>
      <div v-if="!showCard">
        <TableWithSearch
          :items="holidays"
          :headers="allHeaders"
          :openDialog="openDialog"
          @headersUpdated="updateHeaders"
          @refreshItems="refreshItems"
          :showRefresh="true"
        />
      </div>
      <v-dialog
        v-model="openHolidays"
        max-width="500px"
        persistent
        @keydown.esc="reset(false)"
      >
        <Form
          :items="dataInputs"
          @save="saveForm"
          @cancel="reset"
          :maxWidth="maxWidth[0]"
          :mode="mode"
          :show="true"
          :itemsSelect="dataSelects"
          :multiple="true"
          :itemsCheckbox="dataCheckboxes"
          :showDate="true"
          :showDateFrom="true"
          :showDateTo="false"
          :showCheck="false"
        />
      </v-dialog>
      <DeleteDialog
        :showDialog="openDelete"
        :title="titleDelete"
        :confirmDelete="deleteItem"
        :cancelDelete="cancelDelete"
      />
    </v-col>
    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-row>
</template>
<script>
import holidaysGroups from "@/store/gruposDeFeriados/holidaysGroups";
import holidays from "@/store/gruposDeFeriados/holidays";
import schedules from "@/store/horarios/schedules";
import CardsView from "@/components/Complement/CardsView.vue";
import TableWithSearch from "@/components/Complement/TableWithSearch.vue";
import ToolbarTitles from "@/components/Complement/ToolbarTitles.vue";
import ButtonsCardList from "@/components/Complement/ButtonsCardList.vue";
import Form from "@/components/Complement/Form.vue";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import Loader from "@/components/Complement/Loader.vue";
import moment from "moment";
import configTable from "@/store/configuracionDeTablas/configTable.js";
import date from "@/store/common/date";

export default {
  components: {
    TableWithSearch,
    CardsView,
    ToolbarTitles,
    ButtonsCardList,
    DeleteDialog,
    Snackbar,
    Loader,
    Form,
  },
  props: {
    showCard: Boolean,
  },
  data() {
    return {
      title: this.$tc("holidays.holidays"),
      titleTable: "Horarios_Feriados",
      subtitle: "",
      titleDelete: this.$tc("holidays.toHoliday"),
      isLoading: true,
      maxWidth: ["500px", "500px"],
      color: "#82A1D0",
      alert: false,
      textAlert: "",
      itemId: null,
      dataInputs: [
        {
          name: "name",
          label: this.$tc("holidays.nameHoliday"),
          data: "",
          type: "text",
          rules: [
            (v) => !!v || this.$tc("editRegistrations.requerid"),
            (v) =>
              v.length <= 120 || this.$tc("holidayGroups.rulesDataConcept"),
          ],
        },
      ],
      dataCheckboxes: [
        {
          name: "fixed",
          label: this.$tc("holidays.fixed"),
          data: false,
        },
      ],
      headers: [
        {
          text: "Nombre",
          value: "name",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Fecha",
          value: "date",
          class: "primary secondary--text",
          visible: true,
          width: "200px",
          sortable: false,
        },
        {
          text: "Fijo",
          value: "fixed",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
          width: "100px",
        },
      ],
    };
  },
  async mounted() {
    try {
      await Promise.all([
        configTable.commit("setColumns", []),
        new Promise(async (resolve) => {
          let nameTable = this.titleTable;
          try {
            await configTable.dispatch("getColumsTableName", nameTable);
            if (
              configTable.state.colums.length === 0 ||
              configTable.state.colums.length !== this.headers.length
            ) {
              this.saveConfigColumns();
            }
          } catch (error) {
            console.error("Error occurred:", error);
          }
          resolve();
        }),
        holidaysGroups.dispatch("getGroupsHolidays"),
        holidays.dispatch("getHolidays"),
        schedules.dispatch("getSchedules"),
      ]);

      this.isLoading = false;
    } catch (error) {
      console.error(error);
    }
  },

  computed: {
    allHeaders() {
      return configTable.state.colums;
    },
    dataSelects() {
      return [
        {
          name: "holidays",
          label: this.$tc("holidays.holidays"),
          data: [],
          items: this.groupsHolidays,
          itemsValue: "id",
          itemsText: "name",
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
        },
      ];
    },
    holidays() {
      return holidays.state.holidays.map((holiday) => {
        const date = holiday.date;
        return {
          ...holiday,
          subtitle: date,
        };
      });
    },
    groupsHolidays() {
      return holidaysGroups.state.holidaysGroups;
    },
    padding() {
      return holidaysGroups.state.paddingNav;
    },
    mode: {
      get() {
        return holidays.state.mode;
      },
      set(newValue) {
        return newValue;
      },
    },
    openHolidays: {
      get() {
        return holidays.state.openHolidays;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    openDelete: {
      get() {
        return holidays.state.openDelete;
      },
      set(newvalue) {
        return newvalue;
      },
    },
  },
  methods: {
    async refreshItems() {
      await holidays.dispatch("getHolidays");
    },
    updateHeaders(headers) {
      const updatedColums = headers;
      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (
        columnsToSave === undefined ||
        this.allHeaders.length !== this.headers.length ||
        columnsToSave.length === 0
      ) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    generatePayload(data) {
      const gruposFerIds = data.holidays.trim();

      let gruposFer = [];

      if (gruposFerIds) {
        gruposFer = gruposFerIds
          .split(",")
          .map(Number)
          .map((grupoFerId) => {
            return {
              grupoFerId,
            };
          });
      }

      const fechaWithTime = moment.utc(date.state.dateFrom).toISOString();
      const payload = {
        nombre: data.name,
        fecha: fechaWithTime,
        fijo: data.fixed === "true",
      };

      if (gruposFer.length > 0) {
        payload.gruposFer = gruposFer;
      }

      return payload;
    },
    addHoliday(form) {
      const generatedPayload = this.generatePayload(form);
      holidays.commit("setNewHoliday", generatedPayload);
      holidays
        .dispatch("addHoliday")
        .then(() => {
          this.showAlert(this.$tc("holidays.addHolidayAlert"), "#82A1D0");
        })
        .catch((e) => {
          this.showAlert(this.$tc("holidays.addErrorHoliday"), "#ff8d58");
        });
      this.reset(false);
    },

    formatDate(dateString) {
      if (!dateString || !moment(dateString).isValid()) {
        return "";
      }

      const formattedDate = moment(dateString).format("YYYY-MM-DD");
      return formattedDate;
    },
    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;

      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    editHoliday(form) {
      const payload = this.generatePayload(form);
      payload.id = this.itemId;
      holidays.commit("setEditHoliday", payload);
      holidays
        .dispatch("editHoliday")
        .then(() => {
          this.showAlert(this.$tc("holidays.editHolidayAlert"), "#82A1D0");
          holidays.dispatch("getHolidays");
        })
        .catch((e) => {
          this.showAlert(this.$tc("holidays.errorEditHolidayAlert"), "#ff8d58");
        });
      this.reset(false);
    },
    saveForm(items) {
      switch (this.typeForm) {
        case "add":
          this.addHoliday(items);
          break;
        case "edit":
          this.editHoliday(items);
          break;
        default:
          break;
      }
    },

    reset(value) {
      holidays.commit("setOpenHoliday", value);
      this.dataInputs.forEach((item) => {
        item.data = "";
      });
      this.dataSelects.forEach((item) => {
        item.data = [];
      });
    },
    async setEdit(item) {
      await holidays.dispatch("getHolidayId", this.itemId);
      this.dataInputs[0].data = item.name;
      date.state.dateFrom = moment(item.date, "DD-MM-YYYY").format(
        "YYYY-MM-DD"
      );
      this.dataCheckboxes[0].data = item.fixed;
      if (holidays.state.edit && Array.isArray(holidays.state.edit.gruposFer)) {
        this.dataSelects[0].data = holidays.state.edit.gruposFer.map(
          (feriado) => feriado.tipoFerId
        );
      } else {
        this.dataSelects[0].data = [];
      }

      holidays.commit("setOpenHoliday", true);
    },
    async openDialog(type, item) {
      this.typeForm = type;

      switch (this.typeForm) {
        case "add":
          holidays.commit("setMode", this.$tc("holidays.addHoliday"));
          holidays.commit("setOpenHoliday", true);
          date.state.dateFrom = moment().format("YYYY-MM-DD");
          break;
        case "edit":
          this.itemId = item.id;
          holidays.commit("setMode", this.$tc("holidays.editHoliday"));
          await this.setEdit(item);
          break;
        case "delete":
          holidays.commit("setOpenDelete", true);
          this.itemToDelete = item.id;
          break;

        default:
          break;
      }
    },
    deleteItem() {
      holidays.commit("setItemDelete", this.itemToDelete);
      holidays
        .dispatch("deleteHoliday")
        .then(() => {
          this.openDelete = false;
          holidays.commit("setOpenDelete", false);
          this.showAlert(
            (this.textAlert = this.$tc("holidays.deleteAlert")),
            "#82A1D0"
          );
        })
        .catch((e) => {
          this.showAlert(this.$tc("holidays.errorDeleteAlert"), "#ff8d58");
        });
    },
    cancelDelete() {
      this.openDelete = false;
      holidays.commit("setOpenDelete", false);
    },
  },
};
</script>
<style>
.container {
  max-width: 100%;
}
</style>
